/*eslint-disable */
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
const ProductName = ({
    field: { name },
    form: { touched, errors },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [productNames, setproductNames] = useState([])
    const [isloading, setisloading] = useState(false)
    const [oldValue, setoldValue] = useState(null)

    let getData = (id, data) => {
        setisloading(true)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let datas = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                type: [1, 2],
                // searchString: id,
                psId: id,
                userId: userId,
                checkDeletedRecord: 1
            })
        // console.log(datas)
        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?customerNumber=1158&userId=159`, datas, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            if (response.data.status === 1) {
                let tempAddProduct = props.productState;
                // console.log(tempAddProduct[], response.data.data[0].psId)
                tempAddProduct[data].psId = response.data.data[0].psId;
                tempAddProduct[data].rate = response.data.data[0].sellingPrice;
                tempAddProduct[data].quantity = 0;
                tempAddProduct[data].gstAmount = 0;
                tempAddProduct[data].discount = 0;
                tempAddProduct[data].gstPercentage = props.getGstAvailable === 0 ? response.data.data[0].gstPercentage : 0;
                props.getLoad(true)
                setisloading(false)
            } else {
                let tempAddProduct = props.productState;
                tempAddProduct[data].psId = '';
                tempAddProduct[data].rate = 0;
                tempAddProduct[data].quantity = 0;
                tempAddProduct[data].gstAmount = 0;
                tempAddProduct[data].discount = 0;
                tempAddProduct[data].gstPercentage = 0;
                props.getLoad(true)
                setisloading(false)
            }
        }))
            .catch(error => console.log(error))
    }
    useEffect(() => {
        if (oldValue) {
            getData(oldValue.value, oldValue.dataId)
        } else {
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            
            // console.log(APP_CONSTANTS)
            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?customerNumber=${customerNo}&userId=${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": token,
                    "Access-Control-Allow-Origin": "*" 
                }
            }).then((response => {
                if (response.data.status === 1) {
                    setproductNames(response.data.data)
                }

            }))
                .catch(error => console.log(error))
        }
    }, [props.getGstAvailable])
    let productNamesDatas = []
    if (productNames.length > 0) {
        productNames.map((object, index) => {
            let temp = {}
            temp.key = object.psId
            temp.text = object.psDescription
            temp.value = object.psId
            return productNamesDatas[index] = temp
        })
    }


    let getIds = (e, data) => {
        let id = data.value
        let dataId = data.dataId
        getData(id, dataId)
        setoldValue(data)
    }
    return (
        <Dropdown
            selection
            search
            loading={isloading}
            onChange={getIds}
            error={errorText}
            options={productNamesDatas}
            {...props}
        />

    )
}

export default ProductName